import CustomerOpinion from './CustomerOpinion';

// export { TextProps } from './CustomerOpinion';
export default CustomerOpinion;
